import { ActionType, LogLevel, LogType } from '@/utils/logTypes';
import { LogFactory } from '@/logger';

const logButtonInteraction = (
  level: LogLevel,
  action: ActionType,
  type: string,
  name: string,
  message?: string | null,
  obj?: object,
): void => {
  const logData = LogFactory.getLogFormatData(level, LogType.BUTTON, {
    action: {
      type,
      name,
      ...(obj ?? {}),
    },
    message,
  });
  LogFactory.log(level, logData, action);
};

export default {
  loggingButton(type: string, action: ActionType, name: string): void {
    logButtonInteraction(LogLevel.INFO, action, type, name);
  },
  loggingButtonExtra(
    type: string,
    action: ActionType,
    name: string,
    obj: object,
  ): void {
    logButtonInteraction(LogLevel.INFO, action, type, name, null, obj);
  },
  loggingButtonError(
    type: string,
    action: ActionType,
    name: string,
    message: string,
  ): void {
    logButtonInteraction(LogLevel.ERROR, action, type, name, message);
  },
  loggingButtonWarn(
    type: string,
    action: ActionType,
    name: string,
    message: string,
  ): void {
    logButtonInteraction(LogLevel.WARN, action, type, name, message);
  },
};
